export function pillClass(modoOscuro, tone = 'neutral') {
  const tones = {
    success: modoOscuro
      ? 'bg-green-900/40 text-green-200 border-green-700'
      : 'bg-green-50 text-green-800 border-green-200',
    warning: modoOscuro
      ? 'bg-amber-900/40 text-amber-200 border-amber-700'
      : 'bg-amber-50 text-amber-800 border-amber-200',
    danger: modoOscuro
      ? 'bg-red-900/40 text-red-200 border-red-700'
      : 'bg-red-50 text-red-800 border-red-200',
    info: modoOscuro
      ? 'bg-blue-900/40 text-blue-200 border-blue-700'
      : 'bg-blue-50 text-blue-800 border-blue-200',
    accent: modoOscuro
      ? 'bg-[#1F80FF]/20 text-blue-200 border-[#1F80FF]/40'
      : 'bg-[#1F80FF]/10 text-[#004AAD] border-[#1F80FF]/30',
    neutral: modoOscuro
      ? 'bg-gray-800 text-gray-200 border-gray-600'
      : 'bg-gray-100 text-gray-800 border-gray-200',
  };
  return `inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium border ${tones[tone] || tones.neutral}`;
}

export function statusTone(status) {
  if (status === 'active' || status === true) return 'success';
  if (status === 'pending') return 'warning';
  if (status === 'suspended' || status === 'inactive' || status === false) return 'danger';
  return 'neutral';
}

export function roleTone(role) {
  if (role === 'admin') return 'accent';
  if (role === 'company_owner') return 'info';
  if (role === 'employee') return 'success';
  return 'neutral';
}

export function formatArs(value, { compact = false } = {}) {
  const n = Number(value) || 0;
  if (compact) {
    if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
    if (n >= 1_000) return `$${(n / 1_000).toFixed(0)}K`;
  }
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: n % 1 === 0 ? 0 : 2,
  }).format(n);
}

export function isAdminActivity(action = '') {
  const value = String(action).toLowerCase();
  if (/cliente|factura|egreso|invoice|expense|venta|cobranza|recordatorio|conciliaci|recurrente|promesa|referido|contador invitado|nota del contador|pago registrado|gestión de cobranza/.test(value)) {
    return false;
  }
  return /^(team_|admin_|subscription_|export_|sensitive_)/.test(value)
    || /user|usuario|team|empresa|company|plan|admin|suscrip|sistema/.test(value);
}

export function formatDate(value, fallback = '—') {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return date.toLocaleDateString('es-AR');
}
